"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreprocessingGeocodingProvider = void 0;
const GeocodingProvider_1 = require("./GeocodingProvider");
/***
 * This geocodingProvider does preprocessing on the query before passing it into the 'embedded' provider
 */
class PreprocessingGeocodingProvider extends GeocodingProvider_1.default {
    constructor(provider, forwardPreprocessor) {
        super("Preprocessing(" + provider.name + ")");
        this.provider = provider;
        this.forwardPreprocessor = forwardPreprocessor;
        if (!this.forwardPreprocessor) {
            throw "If no preprocessor is given, don't use this class but use the provider directly";
        }
    }
    reverse(l, callback) {
        this.provider.reverse(l, callback);
    }
    forward(query, callback) {
        var _a;
        query = this.forwardPreprocessor(query);
        query.string = (_a = query.string) !== null && _a !== void 0 ? _a : "";
        query.string = query.string.trim();
        if (query.string.length == 0) {
            callback([]);
            return;
        }
        this.provider.forward(query, callback);
    }
}
exports.PreprocessingGeocodingProvider = PreprocessingGeocodingProvider;
